import axios from 'axios';

const apiBaseUrl = '/api/exlCertificateFront/';

async function makeRequest(url, method, data = null, params = null) {
    try {
        const response = await axios({
            method,
            url: `${apiBaseUrl}${url}`,
            data,
            params,
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            },
        });

        return { success: true, error: null, data: response.data };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data.message || 'Ett fel inträffade, vänligen kontakta alltid@consid.se.',
            data: null,
        };
    }
}

export async function GetCertificateById(certificateId) {
    return await makeRequest(`getCertificateById/`, 'get', null, { certificateId });
}

export async function HandleAddCertificate(certificate) {
    const response = await makeRequest('addCertificate/', 'post', certificate);
    if (!response.success) {
        response.error = 'Det gick inte att lägga till certifikatet, vänligen kontakta alltid@consid.se.';
    }
    return response;
}

export async function HandleRemoveCertificate(certificateId) {
    const response = await makeRequest('deleteCertificate/', 'delete', null, { certificateId });
    if (!response.success) {
        response.error = 'Det gick inte att ta bort certifikatet, vänligen kontakta alltid@consid.se.';
    }
    return response;
}

export async function HandleUpdateCertificate(certificate) {
    const response = await makeRequest('updateCertificate/', 'put', certificate);
    if (!response.success) {
        response.error = 'Det gick inte att uppdatera certifikatet, vänligen kontakta alltid@consid.se.';
    }
    return response;
}